import { reatomAsync } from "@reatom/async";
import { UserCreateWithPasswordDto } from "definitions/poizon-sso";
import { API } from "src/api";
import { AppRouter } from "src/App";
import { withIsLoadingAtom } from "src/common/pipes";
import { notificationAtom } from "src/pages/Authentificate/store/notification";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { trackEvent, trackRegistrationError } from "src/util/analytics";

export const registrationRequest = reatomAsync(
  async (ctx, dto: UserCreateWithPasswordDto, source?: string) => {
    try {
      const response = await API.authApi.authControllerSignupUser(dto);
      if (response) {
        // Отслеживаем успешную регистрацию
        trackEvent("registration_completed");

        // Если указан источник, отслеживаем его
        if (source) {
          trackEvent(`registration_from_${source}`);
        }

        notificationAtom(ctx, {
          theme: "success",
          message:
            "Вам на почту отправлено письмо! Перейдите по ссылке в письме или введите код для завершения регистрации.",
        });

        AppRouter.navigate(RoutesPaths.AUTH.VERIFY, {
          state: { email: dto.email },
        });
      }
    } catch (error) {
      // Отслеживаем ошибки регистрации
      trackRegistrationError("failed", {
        email: dto.email,
        errorMessage: error instanceof Error ? error.message : "Unknown error",
      });
      throw error;
    }
  },
  "registrationRequest",
).pipe(withIsLoadingAtom());
